import type { Network, ScheduleFile, RheinData } from './types';

let networkCache: Network | null = null;

export async function loadNetwork(): Promise<Network> {
  if (networkCache) return networkCache;
  const res = await fetch('data/network.json');
  if (!res.ok) throw new Error(`network.json konnte nicht geladen werden (${res.status})`);
  networkCache = (await res.json()) as Network;
  return networkCache;
}

/** Optionaler Fluss-Layer; fehlt die Datei, bleibt die App funktionsfähig. */
export async function loadRhein(): Promise<RheinData | null> {
  try {
    const res = await fetch('data/rhein.json');
    if (!res.ok) return null;
    return (await res.json()) as RheinData;
  } catch {
    return null;
  }
}

export async function loadSchedule(line: string): Promise<ScheduleFile> {
  const res = await fetch(`data/schedule/${line}.json`);
  if (!res.ok) throw new Error(`Fahrplan ${line} konnte nicht geladen werden (${res.status})`);
  return (await res.json()) as ScheduleFile;
}

export interface ScheduleIndex {
  generatedAt: string;
  files: { line: string; file: string; bytes: number; trips: number; services: number }[];
}

export async function loadScheduleIndex(): Promise<ScheduleIndex> {
  const res = await fetch('data/schedule/index.json');
  if (!res.ok) throw new Error('Fahrplanindex fehlt');
  return (await res.json()) as ScheduleIndex;
}
